import HttpService from "./baseHttp";
// 转运计划列表
export const HttpGetTransplanList = (data = {}) => HttpService.get('/api/v2/Transit/findByPage', { params: data });
// 获取目的地
export const HttpGetDestination = (data = {}) => HttpService.get('/api/v2/address/findAddressesOfFba', { params: data });
// 转运仓库
export const HttpGetTransferWarehouse = (data = {}) => HttpService.get('/api/v2/organizationWarehouse/findTransitOrgWarehousesByOrgId', { params: data });
// 管理端转运仓库
export const HttpGetTransferWarehouseAdmin = (data = {}) => HttpService.get('/api/v2/organizationWarehouse/findAllTransitByHostOrgId', { params: data });
// 转运计划详情
export const HttpGetDetail = (data = {}) => HttpService.get('/api/v2/Transit/detail', { params: data });
// sku弹框选择
export const HttpPlanBillErpSku = (data = {}) => HttpService.get("/api/v2/product/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 转运计划删除附件
export const HttpDelAttach = (data = {}) => HttpService.post('/api/v2/Transit/deleteAttachments', data, { baseURL: process.env.VUE_APP_APIURL_FBB }) 
// 转运计划根据id查找sku
export const HttpFindSKU = (data = {}) => HttpService.post('/api/v2/Transit/findProducts', data );
// 转运计划保存更新
export const HttpUpdatePlan = (data = {}) => HttpService.post('/api/v2/Transit/save', data, { headers: { 'Content-Type': 'application/json' } });
// 转运计划保存并提交
export const HttpSubmitUpdatePlan = (data = {}) => HttpService.post('/api/v2/Transit/saveAndSubmit', data, { headers: { 'Content-Type': 'application/json' } });
// 转运计划提交审核
export const HttpTransferPlanSubmit = (data = {}) => HttpService.post('/api/v2/Transit/submit', data);
// 转运计划撤销审核
export const HttpTransferPlanCancelSubmit = (data = {}) => HttpService.post('/api/v2/Transit/revoke', data);
// 转运计划确认发货
export const HttpTransferPlanConfirmDelivery = (data = {}) => HttpService.post('/api/v2/Transit/confirmShipment', data, { headers: { 'Content-Type': 'application/json' } });
// 转运计划取消
export const HttpTransferPlanCancel = (data = {}) => HttpService.post('/api/v2/Transit/cancel', data);
// 转运计划重处理
export const HttpTransferPlanDealAgain = (data = {}) => HttpService.post('/api/v2/Transit/reprocess', data);
// 从入库计划单添加
export const HttpAddByInboundPlan = (data = {}) => HttpService.post('/api/v2/Transit/addByInbound', data, { headers: { "Content-Type": "application/json" } });
// 查询入库计划单
export const HttpFindInboundPlan = (data = {}) => HttpService.get('/api/v2/Transit/findInboundByPage', { params: data });
// 转运计划入库完成
export const HttpInboundComplete = (data = {}) => HttpService.post('/api/v2/Transit/inboundComplete', data);
// 转运计划出库完成
export const HttpOutboundComplete = (data = {}) => HttpService.post('/api/v2/Transit/outboundComplete', data);
// 转运计划审核
export const HttpTransferPlanAudit = (data = {}) => HttpService.post('/api/v2/Transit/aduit', data);
// 转运计划重推附件
export const HttpTransferPlanRepushAttach = (data = {}) => HttpService.post('/api/v2/Transit/repushAttachment', data);
// 转运入库列表
export const HttpTransferInboundList = (data = {}) => HttpService.get('/api/v2/TransitInbound/findByPage', { params: data });
// 转运入库详情
export const HttpTransferInboundDetail = (data = {}) => HttpService.get('/api/v2/TransitInbound/detail', { params: data });
// 取sku
export const HttpGetSKUList = (data = {}) => HttpService.get('/api/v2/Transit/findItemById', { params: data });
// 转运入库保存
export const HttpUpdateInbound = (data = {}) => HttpService.post('/api/v2/TransitInbound/save', data, { headers: { "Content-Type": "application/json" } });
// 转运入库确认
export const HttpTransferInboundConfirm = (data = {}) => HttpService.post('/api/v2/TransitInbound/confirm', data);
// 转运入库取消
export const HttpTransferInboundCancel = (data = {}) => HttpService.post('/api/v2/TransitInbound/cancel', data);
// 转运出库列表
export const HttpTransferOutboundList = (data = {}) => HttpService.get('/api/v2/TransitOutbound/findByPage', { params: data });
// 转运出库详情
export const HttpTransferOutboundDetail = (data = {}) => HttpService.get('/api/v2/TransitOutbound/detail', { params: data });
// 转运出库保存
export const HttpUpdateOutbound = (data = {}) => HttpService.post('/api/v2/TransitOutbound/save', data, { headers: { "Content-Type": "application/json" } });
// 转运出库确认
export const HttpTransferOutboundConfirm = (data = {}) => HttpService.post('/api/v2/TransitOutbound/confirm', data);
// 转运出库取消
export const HttpTransferOutboundCancel = (data = {}) => HttpService.post('/api/v2/TransitOutbound/cancel', data);
// 转运出库一键出库
export const HttpTransferOutboundFastOut = (data = {}) => HttpService.post('/api/v2/TransitOutbound/oneButtonOutbound', data);
// 获取地址信息
export const HttpWarehouseAddress = (data = {}, config) => HttpService.get('/api/v2/address/findByAddressCode', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
// 转运仓库管理端仓库查询
export const HttpGetAdminWarehouse = (data = {}) => HttpService.get('/api/v2/warehouse/findAllTransitByHostOrgId', { params: data });
// 转运计划tab数量
export const HttpGetTransferPlanNumber = (data = {}) => HttpService.post('/api/v2/Transit/getCountByStatus', data);
// 转运计划添加单个
export const HttpTransferPlanAddProduct = (data = {}) => HttpService.post('/api/v2/Transit/addProduct', data, { headers: { "Content-Type": "application/json" } });
// 转运计划清空产品
export const HttpTransferPlanClear = (data = {}) => HttpService.post('/api/v2/Transit/deleteAll', data);
// 转运计划删除单个
export const HttpTransferPlanDeletById = (data = {}) => HttpService.post('/api/v2/Transit/deleteById', data);
// 转运出库添加产品
export const HttpTransferOutboundAddProduct = (data = {}) => HttpService.post('/api/v2/TransitOutbound/addProduct', data, { headers: { "Content-Type": "application/json" } });
// 转运出库清空
export const HttpTransferOutboundClear = (data = {}) => HttpService.post('/api/v2/TransitOutbound/deleteAll', data);
// 转运出库删除单个
export const HttpTransferOutboundDeleteById = (data = {}) => HttpService.post('/api/v2/TransitOutbound/deleteById', data);
// 转运入库添加产品
export const HttpTransferInboundAddProduct = (data = {}) => HttpService.post('/api/v2/TransitInbound/addProduct', data, { headers: { "Content-Type": "application/json" } });
// 转运入库清空
export const HttpTransferInboundClear = (data = {}) => HttpService.post('/api/v2/TransitInbound/deleteAll', data);
// 转运入库删除单个
export const HttpTransferInboundDeleteById = (data = {}) => HttpService.post('/api/v2/TransitInbound/deleteById', data);
// 转运计划管理-仓库接口
export const HttpTransferAdminWarehouseList = (data = {}) => HttpService.post('/api/v2/customerRate/getTransitWarehouseByUser', data);
// 转运计划忽略异常
export const HttpTransferPlanIgonreError = (data = {}) => HttpService.post('/api/v2/Transit/ignoreError', data);
// 转运计划管理重推仓库
export const HttpTransferPushWarehouse = (data = {}) => HttpService.post('/api/v2/Transit/repushWarehouse', data);